export default "__VITE_ASSET__Bfd7BtX9__"